var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.isLoading,
          expression: "isLoading",
        },
      ],
      staticClass: "uni-startPractice onlineTest",
      attrs: { "element-loading-text": "加载中，请稍等..." },
    },
    [
      _c("PromptBox", {
        ref: "promptBox",
        on: {
          setSubmit: _vm.setSubmit,
          clearData: _vm.clearData,
          getRadioSelect: _vm.getRadioSelect,
          destroy: _vm.destroy,
        },
      }),
      _c(
        "div",
        { staticClass: "leftBox", attrs: { id: "leftBox" } },
        [
          _c("div", { staticClass: "title-box" }, [
            _c(
              "div",
              { staticClass: "title" },
              [
                _c("i", {
                  staticClass: "iconfont iconfanhui",
                  on: {
                    click: function ($event) {
                      return _vm.$router.go(-1)
                    },
                  },
                }),
                _vm._l(_vm.otherInfoDTO.title, function (item, index) {
                  return _c("span", { key: index }, [
                    _vm._v(" " + _vm._s(item) + " "),
                    _vm.otherInfoDTO.title.length - 1 !== index
                      ? _c("em")
                      : _vm._e(),
                  ])
                }),
              ],
              2
            ),
            _c("div", { staticClass: "info-box" }, [
              _c("span", { staticClass: "text" }, [
                _vm._v("姓名： " + _vm._s(_vm.studentInfo.student_title)),
              ]),
              _c("span", { staticClass: "text" }, [
                _vm._v("学号： " + _vm._s(_vm.studentInfo.student_code)),
              ]),
              _c("span", { staticClass: "text" }, [
                _vm._v("班级： " + _vm._s(_vm.studentInfo.class_title)),
              ]),
            ]),
          ]),
          _vm._l(_vm.topicLists, function (itemTo, indexTo) {
            return _c(
              "div",
              {
                key: indexTo,
                staticClass: "topicDivButton",
                class: _vm.fontClass,
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "topicDiv",
                    attrs: {
                      id: itemTo.question_style != 6 && `id_${itemTo.sort}`,
                    },
                  },
                  [
                    itemTo.question_style === 1
                      ? _c("ChoiceOne", {
                          attrs: { datas: itemTo },
                          on: {
                            next: function ($event) {
                              return _vm.saveAnswer(itemTo)
                            },
                          },
                        })
                      : _vm._e(),
                    itemTo.question_style === 2
                      ? _c("Judge", {
                          attrs: { datas: itemTo },
                          on: {
                            next: function ($event) {
                              return _vm.saveAnswer(itemTo)
                            },
                          },
                        })
                      : _vm._e(),
                    itemTo.question_style === 3
                      ? _c("ChoiceMultiple", {
                          attrs: { datas: itemTo },
                          on: {
                            next: function ($event) {
                              return _vm.saveAnswer(itemTo)
                            },
                          },
                        })
                      : _vm._e(),
                    itemTo.question_style === 4
                      ? _c("FillBlank", {
                          attrs: { datas: itemTo },
                          on: {
                            next: function ($event) {
                              return _vm.saveAnswer(itemTo)
                            },
                          },
                        })
                      : _vm._e(),
                    itemTo.question_style === 5
                      ? _c("Subjective", {
                          attrs: { datas: itemTo },
                          on: {
                            next: function ($event) {
                              return _vm.saveAnswer(itemTo)
                            },
                          },
                        })
                      : _vm._e(),
                    itemTo.question_style === 6
                      ? _c(
                          "div",
                          [
                            _c("span", { staticClass: "questionMore-title" }, [
                              _vm._v("[" + _vm._s(itemTo.question_title) + "]"),
                            ]),
                            _c("div", {
                              staticClass: "questionAskTitle",
                              attrs: { id: "questionAskTitle" },
                              domProps: { innerHTML: _vm._s(itemTo.content) },
                            }),
                            itemTo.audio_url
                              ? _c(
                                  "div",
                                  { staticClass: "audioDiv" },
                                  _vm._l(
                                    itemTo.audio_url.split(","),
                                    function (itemAudio, indexAudio) {
                                      return _c(
                                        "audio",
                                        {
                                          key: indexAudio,
                                          staticClass: "sourceAudio",
                                          attrs: { controls: "controls" },
                                        },
                                        [
                                          _c("source", {
                                            attrs: {
                                              src: itemAudio,
                                              type: "audio/ogg",
                                            },
                                          }),
                                          _vm._v(
                                            " Your browser does not support the audio element. "
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                            _vm._l(itemTo.child, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: index,
                                  attrs: { id: `id_${item.sort}` },
                                },
                                [
                                  item.question_style === 1
                                    ? _c("ChoiceOne", {
                                        attrs: { datas: item },
                                        on: {
                                          next: function ($event) {
                                            return _vm.saveAnswer(item)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  item.question_style === 4
                                    ? _c("FillBlank", {
                                        attrs: { datas: item },
                                        on: {
                                          next: function ($event) {
                                            return _vm.saveAnswer(item)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  item.question_style === 2
                                    ? _c("Judge", {
                                        attrs: { datas: item },
                                        on: {
                                          next: function ($event) {
                                            return _vm.saveAnswer(item)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  item.question_style === 3
                                    ? _c("ChoiceMultiple", {
                                        attrs: { datas: item },
                                        on: {
                                          next: function ($event) {
                                            return _vm.saveAnswer(item)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                  item.question_style === 5
                                    ? _c("Subjective", {
                                        attrs: { datas: item },
                                        on: {
                                          next: function ($event) {
                                            return _vm.saveAnswer(item)
                                          },
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              )
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            )
          }),
        ],
        2
      ),
      _c(
        "div",
        { staticClass: "mat20", staticStyle: { "min-height": "inherit" } },
        [
          _c("AnswerSheet", {
            ref: "sheet",
            attrs: {
              datas: _vm.topicCard,
              total: _vm.total,
              showTime: true,
              timeDate: _vm.timeDate,
            },
            on: {
              change: _vm.jumpTo,
              submit: _vm.submit,
              forcedSubmit: _vm.forcedSubmit,
            },
          }),
        ],
        1
      ),
      _vm.fromPage !== "courseAdult"
        ? _c("ComponentDialog1", {
            attrs: {
              icon: "fail",
              title: "本次练习得分",
              score: _vm.scoreNum,
              cancelText: "再做一次",
              confirmText: "查看解析",
              modal: false,
              showClose: false,
              visible: _vm.isScoreVisible,
            },
            on: {
              "update:visible": function ($event) {
                _vm.isScoreVisible = $event
              },
              confirm: _vm.confirm,
              cancel: _vm.cancel,
            },
          })
        : _c("ComponentDialog1", {
            attrs: {
              icon: "fail",
              title: "本次练习得分",
              score: _vm.scoreNum,
              showCancelBtn: false,
              confirmText: "返回首页",
              modal: false,
              showClose: false,
              visible: _vm.isScoreVisible,
            },
            on: {
              "update:visible": function ($event) {
                _vm.isScoreVisible = $event
              },
              confirm: _vm.backIndex,
            },
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }